<section class="row mb-2">
  <div class="col-md-4 col-xs-12"></div>
  <div class="col-md-4 col-xs-12"></div>
  <div class="col-md-4 col-xs-12 backToDash">
    <a (click)='backToDashBoard()'>
      <img src='assets/icons/{{baseSiteId}}/chevron-left_green.svg' class="svg-Images" style="width:15px;" alt="left">
      <span class="bc-Dash-Div">Back to dashboard</span></a>
  </div>
</section>
<div class="container vaccineLocatorContent">
  <div class="row row-20 vacc_loc" id="vaccineLocator">
    <section class="col-md-12 col-sm-12 col-xs-12">
      <div class="loc_notifi">
        <div class="col-md-7 col-sm-7 col-xs-12 pl0">
          <h6>{{totalactiveLocationsCount}} of your {{totalLocationsCount}} locations are active</h6>
        </div>

        <div class="col-md-5 col-sm-5 col-xs-12 Search-holder pr0">
          <div class="input-group SearchBar">
            <input type="text" class="form-control" placeholder="Search by location name, city, zip code"
              [(ngModel)]="searchText" id="locationSearch" (ngModelChange)="test($event)" data-di-id="#locationSearch">
            <span class="input-group-btn">
              <button class="btn btn-default" type="button">
                <span class="searchIcon"></span>
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="vacc_table">
        <!--table starts-->
        <table aria-describedby="locatorTable" id="vaccineLocatorTable" class="inflzTab_table table-striped">
          <thead>
            <tr>
              <th scope="col" style="width: 6%;">
                <div class="col-md-2 radioAlign">
                  <label class="mb-3">
                    <!-- <input type="checkbox" id="checkAll" (click)="applySettingAll()" *ngIf="!locationSelectorOn"
                              data-di-id="#checkAll"> -->
                    <span class="checkmark multi_check" style="margin-top:10px;"></span>
                    <input type="checkbox" id="checkAll" [checked]="locationSelectorOn" name="locationSelectorOn"
                      [(ngModel)]="locationSelectorOn" (ngModelChange)="applySettingAll()" data-di-id="#checkAll"> <span
                      class="checkmark multi_check" style="margin-top:10px;"></span>
                  </label>
                </div>
                <!-- <label> 
                                <input type="checkbox" id="checkAll" data-di-id="#checkAll"> <span class="checkmark multi_check"></span>
                            </label> -->
              </th>
              <th scope="col" style="width: 10%;" (click)="sortColumn($event, 'active', ordersList, 'normal')">
                Active
                <i class="my-icon fas fa-caret-down"></i>
              </th>
              <th scope="col" style="width: 21%;" (click)="sortColumn($event, 'location', ordersList, 'normal')">
                Location
                <i class="my-icon fas fa-caret-down"></i>
              </th>
              <th scope="col" style="width: 21%;" (click)="sortColumn($event, 'location', ordersList, 'normal')">
                Address
                <i class="my-icon fas fa-caret-down"></i>
              </th>
              <th scope="col" style="width: 12%;">
                Phone
              </th>
              <th scope="col" style="width: 15%;" (click)="sortColumn($event, 'flubok', ordersList, 'normal')">
                Flubok Quadrivalent Influenza Vaccine
                <!-- <i class="my-icon fas fa-caret-down"></i> -->
              </th>
              <th scope="col" style="width: 15%;" (click)="sortColumn($event, 'fluzone', ordersList, 'normal')">
                Fluzone High-Dose Quadrivalent Influenza Vaccine
                <!-- <i class="my-icon fas fa-caret-down"></i> -->
              </th>
              <th scope="col" style="width: 6%;">

              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="locationSelectorOn">
              <td></td>
              <td class="status-txt loc-switch align-baseline">

                <span class="loc_stat">

                  <label class="switch">
                    <input type="checkbox" class="imCheck" name="isAllActive" [(ngModel)]="isAllActive"
                      (click)="changeEnrollFlag('All','enrollflag',$event)">

                    <span class="slider round"></span>

                  </label>

                  <span *ngIf="isAllActive">Active</span>
                  <span *ngIf="!isAllActive">Inactive</span>
                </span>

              </td>
              <td colspan="2" class="locationSelector align-baseline">
                <div class="p-4">
                  <span class="d-block mb-2">All locations selected({{totalLocationsCount}})</span>
                  <div class="loc-btn mob-loc-btn recursive-loc-btn">
                    <button class="popover-close btn white-button popover-cancel-button mr-1">
                      <a (click)="cancelAllLocation()">Cancel</a></button>
                    <button class="btn btn-primary applyBtnStl" (click)="clickApplytoAll()" data-toggle="popover"
                      data-placement="top" data-target="apply_all" data-original-title="" title="">
                      Apply to all</button>
                    <!--Popover content for Delete start-->
                    <div class="edit-popover rr_apply-all" *ngIf="confirmStatus">
                      <div class="hide" id="apply_all">
                        <p class="bold-12 product_trash product_trash_text">
                          Are you sure you want to apply these settings to all the locations selected?</p>
                        <button (click)="cancelPopUp()"
                          class="popover-close btn white-button popover-cancel-button mr-1">
                          Cancel</button>
                        <button class="btn btn-primary" (click)="callsaveAction()">
                          &nbsp;Apply&nbsp;</button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td></td>
              <td class="status-txt loc-switch align-baseline pl-1">

                <span class="loc_stat" *ngIf="isAllActive">

                  <label class="switch">
                    <input type="checkbox" class="imCheck" name="isAllFlubokActive" [(ngModel)]="isAllFlubokActive"
                      (click)="changeEnrollFlag('All','flubokActive',$event)">

                    <span class="slider round"></span>

                  </label>

                  <span *ngIf="!isAllFlubokActive">Not Offered</span>
                  <span *ngIf="isAllFlubokActive">Offered</span>
                </span>

              </td>
              <td class="status-txt loc-switch align-baseline pl-1">

                <span class="loc_stat" *ngIf="isAllActive">

                  <label class="switch">
                    <input type="checkbox" class="imCheck" name="isAllFlubokHighDoseActive"
                      [(ngModel)]="isAllFlubokHighDoseActive"
                      (click)="changeEnrollFlag('All','flubokHighDoseActive',$event)">

                    <span class="slider round"></span>

                  </label>

                  <span *ngIf="!isAllFlubokHighDoseActive">Not Offered</span>
                  <span *ngIf="isAllFlubokHighDoseActive">Offered</span>

                </span>

              </td>
              <td></td>
            </tr>
            <ng-container *ngIf="ordersList?.length>0">
              <ng-container *ngFor="let data of ordersList; let i = index">
                <tr id="{{'rowIdOnRead'+i}}" *ngIf="!data.editModeOn">
                  <td style="width: 6%;">
                    <div class="input-wrapper-div">
                      <label class="mb-3">
                        <input *ngIf="data?.thisEleChecked" checked (click)="selectRadioFrRw(data?.locatorId, $event)"
                          type="checkbox" class="row-selector">

                        <input *ngIf="!data?.thisEleChecked" (click)="selectRadioFrRw(data?.locatorId, $event)"
                          type="checkbox" class="row-selector">
                        <span class="checkmark"></span>
                      </label>
                    </div>
                  </td>
                  <td style="width: 10%;" class="status-txt loc-switch pl-1">
                    <span class="loc_stat">

                      <label class="switch"> <input type="checkbox" class="imCheck"
                          (click)="changeEnrollFlag(data?.locatorId,'enrollflag',false)" *ngIf="data.statusId!=2"
                          checked>
                        <input type="checkbox" class="imCheck"
                          (click)="changeEnrollFlag(data?.locatorId,'enrollflag',true)" *ngIf="data.statusId==2">

                        <span class="slider round"></span>

                      </label>

                      <span *ngIf="data?.statusId!=2">Active</span>
                      <span *ngIf="data?.statusId==2">Inactive</span>

                    </span>
                  </td>
                  <td style="width: 21%;">
                    <span>{{data.customerName}}</span>
                  </td>
                  <td style="width: 21%;" class="status-txt">
                    <span>{{data.address}}, {{data.city}}, {{data.state}}, {{data.zipcode}}</span>
                  </td>
                  <td style="width: 12%;" class="status-txt">
                    <span> {{data.phone}}</span>
                  </td>

                  <td style="width: 12%;" class="status-txt loc-switch pl-1">
                    <span class="loc_stat">

                      <!-- <label class="switch"> <input type="checkbox" class="imCheck"
                          (click)="changeEnrollFlag(data?.locatorId,'flubokHighDoseActive',false)"
                          *ngIf="data.flubokHighDoseActive" checked>
                        <input type="checkbox" class="imCheck"
                          (click)="changeEnrollFlag(data?.locatorId,'flubokHighDoseActive',true)"
                          *ngIf="!data.flubokHighDoseActive">

                        <span class="slider round"></span>

                      </label> -->

                      <label class="switch" *ngIf="data?.statusId!=2 && data?.fluBlockOptedIn!='Not Available'">
                        <input type="checkbox" class="imCheck"
                          (click)="changeEnrollFlag(data?.locatorId,'flubokHighDoseActive',false)"
                          *ngIf="data?.fluBlockOptedIn=='Offered'" checked>
                        <input type="checkbox" class="imCheck"
                          (click)="changeEnrollFlag(data?.locatorId,'flubokHighDoseActive',true)"
                          *ngIf="data?.fluBlockOptedIn!='Offered'">
                        <span class="slider round"></span>
                      </label>


                      <!-- <span *ngIf="data.flubokHighDoseActive">Offered</span> -->
                      <span *ngIf="data?.statusId!=2 && data?.fluBlockOptedIn">{{data?.fluBlockOptedIn}}</span>
                      <span *ngIf="data?.statusId!=2 && !data?.fluBlockOptedIn">Not Available</span>

                    </span>
                  </td>
                  <td style="width: 12%;" class="status-txt loc-switch pl-2">
                    <span class="loc_stat">

                      <!-- <label class="switch">
                        <input type="checkbox" class="imCheck"
                          (click)="changeEnrollFlag(data?.locatorId,'flubokActive',false)" *ngIf="data.flubokActive"
                          checked>

                        <input type="checkbox" class="imCheck"
                          (click)="changeEnrollFlag(data?.locatorId,'flubokActive',true)" *ngIf="!data.flubokActive">

                        <span class="slider round"></span>

                      </label> -->

                      <span *ngIf="data?.statusId!=2">{{data?.fluZoneOptedIn}}</span>
                      <!-- <span *ngIf="!data.flubokActive">Not Offered</span> -->
                      <label class="switch" *ngIf="data?.statusId!=2 && data?.fluZoneOptedIn!='Not Available'">
                        <input type="checkbox" class="imCheck"
                          (click)="changeEnrollFlag(data?.locatorId,'flubokActive',false)"
                          *ngIf="data?.fluZoneOptedIn=='Offered'" checked>
                        <input type="checkbox" class="imCheck"
                          (click)="changeEnrollFlag(data?.locatorId,'flubokActive',true)"
                          *ngIf="data?.fluZoneOptedIn!='Offered'">
                        <span class="slider round"></span>
                      </label>
                    </span>
                  </td>
                  <td class="loc-edit">

                    <div class="show-msg alert-danger common-error" style="display: none;">

                      Please select the check box to make changes

                    </div>

                    <div *ngIf="!editOn && !locationSelectorOn" class="d-flex p-1 pt-3"><img class="editIcon"
                        src="../assets/icons/editIcon.png" alt="icon">

                      <a class="edit allctn-edit" href="javascript:void(0);" (click)="editModeOn(data.locatorId)"
                        target="" title="Edit">Edit</a>
                    </div>
                    <div *ngIf="editOn || locationSelectorOn" class="d-flex p-1"><img class="editIcon"
                        src="../assets/icons/edit_disable.svg" alt="icon">

                      <a class="allctn-edit2" target="" title="Edit">Edit</a>
                    </div>




                  </td>
                  <!-- <td class="loc-edit">
                            <div class="show-msg alert-danger common-error" style="display: none;">
                                Please select the check box to make changes
                            </div> 
                            <img class="editIcon" src="../assets/icons/editIcon.png" alt="icon">
                            <a class="edit allctn-edit" href="javascript:void(0);" target="" title="Edit">Edit</a>

                        </td> -->
                </tr>

                <tr id="{{'rowId'+i}}" *ngIf="data.editModeOn">
                  <td colspan="8">
                    <div class="row pt-3 pb-3">
                      <div class="col-xs-12 col-md-2">
                        <div class="status-txt loc-switch float-right">
                          <span class="loc_stat">
                            <label class="switch">
                              <input type="checkbox" class="imCheck"
                                (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'enrollflag',false)"
                                *ngIf="data.statusId!=2" checked>
                              <input type="checkbox" class="imCheck"
                                (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'enrollflag',true)"
                                *ngIf="data.statusId==2">
                              <span class="slider round"></span>
                            </label>
                            <span *ngIf="data.statusId!=2">Active</span>
                            <span *ngIf="data.statusId==2">Inactive</span>
                          </span>
                        </div>
                      </div>
                      <div class="col-xs-12 col-md-6">
                        <div class="row mb-3">
                          <div class="col-xs-12 col-md-8">
                            <div class="inputTitle">
                              <label class="mb-2">
                                Location name
                              </label>
                              <input #locationName class="texttype2 w-90 ml-4"
                                (keyup)="inputValidation(locationName.value,'name')" type="text"
                                [(ngModel)]="dataSetForEdit.customerName" name="location"><br />
                              <span class="redmsgFax" *ngIf="nameErrorMsg">This field is required</span>
                            </div>
                          </div>
                          <div class="col-xs-12 col-md-4">
                            <div class="inputTitle">
                              <label class="mb-2">
                                Account #
                              </label>
                              <input #locationName class="texttype2 w-90 ml-4" type="text"
                                [(ngModel)]="dataSetForEdit.mdg_num" name="account" disabled><br />
                            </div>
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-xs-12 col-md-8">
                            <div class="inputTitle">
                              <label class="mb-2">
                                Address
                              </label>
                              <input #address class="texttype2 w-90 ml-4"
                                (keyup)="inputValidation(address.value,'address')" type="text"
                                [(ngModel)]="dataSetForEdit.address" name="address"><br />
                              <span class="redmsgFax" *ngIf="addressErrorMsg">This field is required</span>
                            </div>
                          </div>
                          <div class="col-xs-12 col-md-4">
                            <div class="inputTitle">
                              <label class="mb-2">
                                Phone
                              </label>
                              <input type="text" #phoneNumber
                                onkeypress="return 
                                  (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                                class="texttype w-90 ml-4"
                                (keyup)="validateFaxNumber(phoneNumber.value,'phone',dataSetForEdit.locatorId)"
                                [(ngModel)]="dataSetForEdit.phone" id="faxcontactmethod{{i}}" name="fax{{i}}">
                              <span class="redmsgFax" *ngIf="phoneErrorMsg">This field is required</span>
                            </div>
                          </div>
                        </div>
                        <div class="row mb-3">
                          <div class="col-xs-12 col-md-4">
                            <div class="inputTitle">
                              <label class="mb-2">
                                City
                              </label>
                              <input #city class="texttype2 w-90 ml-4" (keyup)="cityvalidation(city.value)" type="text"
                                [(ngModel)]="dataSetForEdit.city" name="address"><br />
                              <span class="redmsgFax" *ngIf="cityErrorMsg">This field is required</span>
                              <span class="redmsgFax redmsgCity" *ngIf="cityErrorMsg2">This field accepts alphabets and
                                spaces.</span>
                            </div>
                          </div>
                          <div class="col-xs-12 col-md-4">
                            <div class="inputTitle vax-location">
                              <label class="mb-2">
                                State
                              </label>
                              <ng-select [items]="statesArr" bindLabel="isocode" [clearable]="false"
                                placeholder="Please select" [(ngModel)]="dataSetForEdit.state" name="state">
                              </ng-select>
                            </div>
                          </div>
                          <div class="col-xs-12 col-md-4">
                            <div class="inputTitle">
                              <label class="mb-2">
                                Zip code
                              </label>
                              <input #zip class="texttype2 w-90 ml-4" (keyup)="numberValidation(zip.value)" type="text"
                                [(ngModel)]="dataSetForEdit.zipcode" name="zipcode"><br />
                              <span class="redmsgFax" *ngIf="zipcodeErrorMsg">This field is required</span>
                              <span class="redmsgFax redmsgCity" *ngIf="zipcodeErrorMsg2">Please enter valid zip
                                code</span>
                            </div>
                          </div>
                        </div>
                        <div class="row mb-3 mt-4">
                          <div class="col-xs-12 col-md-12">
                            <div class="ml-4">
                              <!-- <button *ngIf="phoneErrorMsg" disabled (click)="cancelEditSection(data.locatorId)"
                                    class="popover-close btn white-button popover-cancel-button mr-3">
                                    Cancel</button> -->
                              <button (click)="cancelEditSection(data.locatorId)"
                                class="popover-close btn white-button popover-cancel-button mr-3">
                                Cancel</button>
                              <button
                                *ngIf="phoneErrorMsg||cityErrorMsg||cityErrorMsg2 || zipcodeErrorMsg2 || zipcodeErrorMsg || addressErrorMsg || nameErrorMsg"
                                disabled (click)="SaveAction()" class="btn btn-primary">
                                &nbsp;Save&nbsp;</button>
                              <button
                                *ngIf="!phoneErrorMsg && !cityErrorMsg2 && !zipcodeErrorMsg2 && !zipcodeErrorMsg && !addressErrorMsg && !nameErrorMsg"
                                (click)="SaveAction()" class="btn btn-primary">
                                &nbsp;Save&nbsp;</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-xs-12 col-md-4">
                        <div class="row">
                          <div class="col-5 ml-3">
                            <div class="status-txt loc-switch">
                              <span class="loc_stat" *ngIf="data.isSelected">
                                <label class="switch"
                                  *ngIf="data?.statusId!=2 && data?.fluBlockOptedIn!='Not Available'"> <input
                                    type="checkbox" class="imCheck"
                                    (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokHighDoseActive',false)"
                                    *ngIf="data?.fluBlockOptedIn=='Offered'" checked>
                                  <input type="checkbox" class="imCheck"
                                    (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokHighDoseActive',true)"
                                    *ngIf="data?.fluBlockOptedIn!='Offered'">
                                  <span class="slider round"></span>
                                </label>


                                <!-- <span *ngIf="data.flubokHighDoseActive">Offered</span> -->
                                <span *ngIf="data?.statusId!=2">{{data?.fluBlockOptedIn}}</span>

                              </span>

                            </div>
                          </div>
                          <div class="col-5 ml-2 p-0">
                            <div class="status-txt loc-switch">

                              <span class="loc_stat">

                                <span *ngIf="data?.statusId!=2">{{data?.fluZoneOptedIn}}</span>
                                <!-- <span *ngIf="!data.flubokActive">Not Offered</span> -->
                                <label class="switch"
                                  *ngIf="data?.statusId!=2 && data?.fluZoneOptedIn!='Not Available'"> <input
                                    type="checkbox" class="imCheck"
                                    (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokActive',false)"
                                    *ngIf="data?.fluZoneOptedIn=='Offered'" checked>
                                  <input type="checkbox" class="imCheck"
                                    (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokActive',true)"
                                    *ngIf="data?.fluZoneOptedIn!='Offered'">
                                  <span class="slider round"></span>
                                </label>
                              </span>
                            </div>
                          </div>
                          <!-- <div class="col-md-1">&nbsp;</div> -->
                        </div>
                      </div>
                    </div>
                  </td>

                  <!-- 

                        <td colspan="2">
    
                          <div class="row" #editContentSection>
                            <div class="col-md-12 editLocation">
                              <div class="row">
                                <div class="col-md-12 addresscontainer">
                                 
                                  <p class="locationTitle">Location name:<br />
                                    <input #emailVal class="texttype2" (keyup)="validateEmailmethod(emailVal.value)"
                                      type="email" [(ngModel)]="dataSetForEdit.email" name="servation_contact"><br />
                                    <span class="redmsgFax" *ngIf="emailErrorMsg2">This field is required</span>
                                    <span class="redmsgFax" *ngIf="emailErrorMsg && !emailErrorMsg2">Please enter the valid
                                      email
                                      address</span>
                                  </p>

                                  <p class="locationTitle">Address:<br />
                                    <input #emailVal class="texttype2" (keyup)="validateEmailmethod(emailVal.value)"
                                      type="email" [(ngModel)]="dataSetForEdit.email" name="servation_contact"><br />
                                    <span class="redmsgFax" *ngIf="emailErrorMsg2">This field is required</span>
                                    <span class="redmsgFax" *ngIf="emailErrorMsg && !emailErrorMsg2">Please enter the valid
                                      email
                                      address</span>
                                  </p>

                                  <p class="locationTitle">City:<br />
                                 <input #faxnumber class="texttype2"
                                      onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                                      type="text" (keyup)="validateFaxNumber(faxnumber.value,'fax',dataSetForEdit.locatorId)"
                                      [(ngModel)]="dataSetForEdit.fax" name="servation_contact" /><br />
                                    <span class="redmsgFax" *ngIf="faxErrorMsg">This field is required</span>
                                  </p>

                                  <p class="locationTitle">State:<br />
                                 <input #faxnumber class="texttype2"
                                      onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                                      type="text" (keyup)="validateFaxNumber(faxnumber.value,'fax',dataSetForEdit.locatorId)"
                                      [(ngModel)]="dataSetForEdit.fax" name="servation_contact" /><br />
                                    <span class="redmsgFax" *ngIf="faxErrorMsg">This field is required</span>
                                  </p>
                                  <p>
                                    <button *ngIf="phoneErrorMsg" disabled (click)="cancelEditSection(data.locatorId)"
                                      class="popover-close btn white-button popover-cancel-button">
                                      Cancel</button>
                                    <button *ngIf="!phoneErrorMsg" (click)="cancelEditSection(data.locatorId)"
                                      class="popover-close btn white-button popover-cancel-button">
                                      Cancel</button>
                                    <button
                                      *ngIf="phoneErrorMsg || faxErrorMsg || emailErrorMsg || emailErrorMsg2 || nameErrorMsg"
                                      disabled (click)="SaveAction()" class="btn blue-btn">
                                      &nbsp;Save&nbsp;</button>
                                    <button
                                      *ngIf="!phoneErrorMsg && !faxErrorMsg && !emailErrorMsg && !emailErrorMsg2 && !nameErrorMsg"
                                      (click)="SaveAction()" class="btn blue-btn">
                                      &nbsp;Save&nbsp;</button>
                                  </p>
                                </div>
    
                              </div>
    
    
    
    
                            </div>
                            <div class="col-md-1">

                            </div>
                            <div class="col-md-1"></div>
                            <div class="col-md-1"></div>
                            <div class="col-md-1"></div>
                            <div class="col-md-4"></div>
                          </div>
                        </td>
                        <td scope="col" class="restCols_phone valignTop">
                          <p class="locationTitle">Account #:<br />
                          <input #faxnumber class="texttype2"
                              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                              type="text" (keyup)="validateFaxNumber(faxnumber.value,'fax',dataSetForEdit.locatorId)"
                              [(ngModel)]="dataSetForEdit.fax" name="servation_contact" /><br />
                            <span class="redmsgFax" *ngIf="faxErrorMsg">This field is required</span>
                          </p>
                          <p class="locationTitle">Phone:<br />
                           <input #faxnumber class="texttype2"
                              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                              type="text" (keyup)="validateFaxNumber(faxnumber.value,'fax',dataSetForEdit.locatorId)"
                              [(ngModel)]="dataSetForEdit.fax" name="servation_contact" /><br />
                            <span class="redmsgFax" *ngIf="faxErrorMsg">This field is required</span>
                          </p>
                          <p class="locationTitle">Zip code:<br />
                            <input #faxnumber class="texttype2"
                              onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                              type="text" (keyup)="validateFaxNumber(faxnumber.value,'fax',dataSetForEdit.locatorId)"
                              [(ngModel)]="dataSetForEdit.fax" name="servation_contact" /><br />
                            <span class="redmsgFax" *ngIf="faxErrorMsg">This field is required</span>
                          </p>
                        </td>
                       
                        <td colspan="2" scope="col" class="restCols_phone valignTop">
                        
                        </td> -->
                </tr>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="ordersList?.length==0">
              <tr>
                <td colspan="7" class="alignCenter">No matching locations</td>
              </tr>
            </ng-container>

          </tbody>
        </table>
        <!--table ends-->

        <!--mobile view starts-->
          <div id="applyVaccineLocatorTable">

            <div class="mb-location">

              <div class="restCols">

                <div class="row">
                  <div class="col-6 radioAlign">
                    <label class="mb-3">
                      <!-- <input type="checkbox" id="checkAll" (click)="applySettingAll()" *ngIf="!locationSelectorOn"
                                data-di-id="#checkAll"> -->
                      <span class="checkmark multi_check" style="margin-top:10px;"></span>
                      <input type="checkbox" id="checkAll" [checked]="locationSelectorOn" name="locationSelectorOn"
                        [(ngModel)]="locationSelectorOn" (ngModelChange)="applySettingAll()" data-di-id="#checkAll"> <span
                        class="checkmark multi_check" style="margin-top:10px;"></span>
                    </label>
                  </div>
                  <div class="col-6 topMargin-select">
                    Location
                  </div>
                </div>

              </div>

            </div>

            <div>

              <div *ngIf="locationSelectorOn" class="p-1 pb-2 bg-location">
                <div class="locationSelector locationSelector-height">

                  <span>All locations selected({{totalLocationsCount}})</span>

                  <div class="status-txt loc-switch st-outline">

                    <span class="loc_stat">

                      <label class="switch">
                        <input type="checkbox" class="imCheck" name="isAllActive" [(ngModel)]="isAllActive"
                          (click)="changeEnrollFlag('All','enrollflag',$event)">
    
                        <span class="slider round"></span>
    
                      </label>
    
                      <span *ngIf="isAllActive">Active</span>
                      <span *ngIf="!isAllActive">Inactive</span>
                    </span>

                  </div>

                  <div class="status-txt loc-switch st-outline">
                    <span class="loc_stat" *ngIf="isAllActive">

                      <label class="switch">
                        <input type="checkbox" class="imCheck" name="isAllFlubokActive" [(ngModel)]="isAllFlubokActive"
                          (click)="changeEnrollFlag('All','flubokActive',$event)">
    
                        <span class="slider round"></span>
    
                      </label>
    
                      <span *ngIf="!isAllFlubokActive">Not Offered</span>
                      <span *ngIf="isAllFlubokActive">Offered</span>
                    </span>
                  </div>

                  <div class="status-txt loc-switch st-outline">
                    <span class="loc_stat" *ngIf="isAllActive">

                      <label class="switch">
                        <input type="checkbox" class="imCheck" name="isAllFlubokHighDoseActive"
                          [(ngModel)]="isAllFlubokHighDoseActive"
                          (click)="changeEnrollFlag('All','flubokHighDoseActive',$event)">
    
                        <span class="slider round"></span>
    
                      </label>
    
                      <span *ngIf="!isAllFlubokHighDoseActive">Not Offered</span>
                      <span *ngIf="isAllFlubokHighDoseActive">Offered</span>
    
                    </span>
                  </div>

                  <div id="AllBtn" class="loc-btn mob-loc-btn recursive-loc-btn mt-1">
                    <button class="popover-close btn white-button popover-cancel-button mr-1">
                      <a (click)="cancelAllLocation()">Cancel</a></button>
                    <button class="btn btn-primary applyBtnStl" (click)="clickApplytoAll();toggle(p2)" 
                    [ngbPopover]="popContentDeleteMob" triggers="manual" #p2="ngbPopover" placement="top"
                    popoverClass="custom-rec-reserv-popover-mob">
                      Apply to all</button>

                    <!--Popover content for Delete start-->
                    <ng-template #popContentDeleteMob>

                      <div>
                        <div class="hide" id="apply_all">
                          <p class="bold-12 product_trash product_trash_text">
                            Are you sure you want to apply these settings to all the locations selected?</p>
                          <div class="d-flex">
                            <button (click)="toggle(p2)"
                            class="btn-secondary">
                            Cancel</button>
                          <button class="btn-primary ml-1" (click)="callsaveAction();toggle(p2)">
                            &nbsp;Apply&nbsp;</button>
                          </div>
                        </div>
                      </div>

                    </ng-template>
                  </div>

                </div>
              </div>
            </div>

            <ng-container *ngIf="ordersList?.length>0">
            <section *ngFor="let data of ordersList; let i = index" class="pt-3">
            <div *ngIf="!data.editModeOn" id="{{'rowIdOnReadMob'+i}}">
              <div class="row p-1">

                <div class="col-6 mb-1">
                  <label class="col-title">
                    Select
                  </label>
                </div>

                <div class="col-6 mt-2 p-2 select-radio-div">
                  <label>
                    <input *ngIf="data?.thisEleChecked" checked (click)="selectRadioFrRw(data?.locatorId, $event)"
                    type="checkbox" class="row-selector">
                    <input *ngIf="!data?.thisEleChecked" (click)="selectRadioFrRw(data?.locatorId, $event)"
                    type="checkbox" class="row-selector">
                    <span class="checkmark"></span>
                  </label>

                </div>

                <div class="col-6">
                  <label class="col-title">
                    Location
                  </label>
                </div>
                <div class="col-6 mt-2 p-0">
                  <label class="desc">
                    <!-- {{data?.locationName}} -->
                    {{data.customerName}}
                  </label>
                </div>

                <div class="col-6">
                  <label class="col-title">
                    Address
                  </label>
                </div>

                <div class="col-6 mt-2 p-0">
                  <label class="desc">
                    {{data.address}}, {{data.city}}, {{data.state}}, {{data.zipcode}}
                  </label>
                </div>

                <div class="col-6">
                  <label class="col-title">
                    Phone
                  </label>
                </div>

                <div class="col-6 mt-2 phoneMobilePadding">
                  <label class="desc">
                    {{data.phone}}
                  </label>

                </div>

                <div class="col-6">
                  <label class="col-title">
                    Status
                  </label>
                </div>
                <div class="col-6 status-txt loc-switch mt-3">
                  <span class="loc_stat">
                    <label class="switch"> 
                      <input type="checkbox" class="imCheck"
                      (click)="changeEnrollFlag(data?.locatorId,'enrollflag',false)" *ngIf="data.statusId!=2"
                      checked>
                      <input type="checkbox" class="imCheck"
                      (click)="changeEnrollFlag(data?.locatorId,'enrollflag',true)" *ngIf="data.statusId==2">
                      <span class="slider round"></span>
                    </label>
                    <span *ngIf="data?.statusId!=2">Active</span>
                    <span *ngIf="data?.statusId==2">Inactive</span>
                  </span>
                </div>

                <div class="col-6">
                  <label class="col-title" *ngIf="data?.statusId!=2">
                    Flubok Quadrivalent Influenza Vaccine
                  </label>
                </div>
                <div class="col-6 status-txt loc-switch mt-3">
                  <span class="loc_stat">
                    <label class="switch" *ngIf="data?.statusId!=2 && data?.fluBlockOptedIn!='Not Available'">
                      <input type="checkbox" class="imCheck"
                        (click)="changeEnrollFlag(data?.locatorId,'flubokHighDoseActive',false)"
                        *ngIf="data?.fluBlockOptedIn=='Offered'" checked>
                      <input type="checkbox" class="imCheck"
                        (click)="changeEnrollFlag(data?.locatorId,'flubokHighDoseActive',true)"
                        *ngIf="data?.fluBlockOptedIn!='Offered'">
                      <span class="slider round"></span>
                    </label>
                    <!-- <span *ngIf="data.flubokHighDoseActive">Offered</span> -->
                    <span *ngIf="data?.statusId!=2">{{data?.fluBlockOptedIn}}</span>
                  </span>
                </div>

                <div class="col-6">
                  <label class="col-title" *ngIf="data?.statusId!=2">
                    Fluzone High-Dose Quadrivalent Influenza Vaccine
                  </label>
                </div>
                <div class="col-6 status-txt loc-switch mt-3">
                  <span class="loc_stat">
                    <span *ngIf="data?.statusId!=2">{{data?.fluZoneOptedIn}}</span>
                    <!-- <span *ngIf="!data.flubokActive">Not Offered</span> -->
                    <label class="switch" *ngIf="data?.statusId!=2 && data?.fluZoneOptedIn!='Not Available'">
                      <input type="checkbox" class="imCheck"
                        (click)="changeEnrollFlag(data?.locatorId,'flubokActive',false)"
                        *ngIf="data?.fluZoneOptedIn=='Offered'" checked>
                      <input type="checkbox" class="imCheck"
                        (click)="changeEnrollFlag(data?.locatorId,'flubokActive',true)"
                        *ngIf="data?.fluZoneOptedIn!='Offered'">
                      <span class="slider round"></span>
                    </label>
                  </span>
                </div>




                <div class="col-12 text-center">

                  <div *ngIf="!editOn && !locationSelectorOn"><img class="editIcon"
                    src="../assets/icons/editIcon.png" alt="icon">

                    <a class="edit allctn-edit" href="javascript:void(0);" (click)="editModeOn(data.locatorId)"
                    target="" title="Edit">Edit</a>
                  </div>
                  <div *ngIf="editOn || locationSelectorOn"><img class="editIcon"
                    src="../assets/icons/edit_disable.svg" alt="icon">

                    <a class="allctn-edit2" target="" title="Edit">Edit</a>
                  </div>

                </div>

              </div>
            </div>
            <div id="{{'rowIdMob'+i}}" *ngIf="data.editModeOn">
              <div class="row p-1">

                <div class="col-6">
                  <label class="col-title">
                    Location
                  </label>
                </div>
                <div class="col-6 mt-2 p-0">
                  <input #locationName class="texttype2 w-90"
                  (keyup)="inputValidation(locationName.value,'name')" type="text"
                  [(ngModel)]="dataSetForEdit.customerName" name="location"><br />
                  <span class="redmsgFax" *ngIf="nameErrorMsg">This field is required</span>
                </div>

                <div class="col-6">
                  <label class="col-title">
                    Address
                  </label>
                </div>
                <div class="col-6 mt-2 p-0">
                  <input #address class="texttype2 w-90"
                  (keyup)="inputValidation(address.value,'address')" type="text"
                  [(ngModel)]="dataSetForEdit.address" name="address"><br />
                <span class="redmsgFax" *ngIf="addressErrorMsg">This field is required</span>
                </div>

                <div class="col-6">
                  <label class="col-title">
                    Account #
                  </label>
                </div>
                <div class="col-6 mt-2 p-0">
                  <input #locationName class="texttype2 w-90" type="text"
                  [(ngModel)]="dataSetForEdit.mdg_num" name="account" disabled><br />
                </div>

                <div class="col-6">
                  <label class="col-title">
                    Phone
                  </label>
                </div>
                <div class="col-6 mt-2 phoneMobilePadding">
                  <input type="text" #phoneNumber
                  onkeypress="return 
                    (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  class="texttype w-90"
                  (keyup)="validateFaxNumber(phoneNumber.value,'phone',dataSetForEdit.locatorId)"
                  [(ngModel)]="dataSetForEdit.phone" id="faxcontactmethod{{i}}" name="fax{{i}}">
                <span class="redmsgFax" *ngIf="phoneErrorMsg">This field is required</span>
                </div>

                <div class="col-6">
                  <label class="col-title">
                    City
                  </label>
                </div>
                <div class="col-6 mt-2 p-0">
                  <input #city class="texttype2 w-90" (keyup)="cityvalidation(city.value)" type="text"
                  [(ngModel)]="dataSetForEdit.city" name="address"><br />
                <span class="redmsgFax" *ngIf="cityErrorMsg">This field is required</span>
                <span class="redmsgFax redmsgCity" *ngIf="cityErrorMsg2">This field accepts alphabets and
                  spaces.</span>
                </div>

                <div class="col-6">
                  <label class="col-title">
                    State
                  </label>
                </div>
                <div class="col-6 mt-2 p-0">
                  <ng-select [items]="statesArr" bindLabel="isocode" [clearable]="false"
                  placeholder="Please select" [(ngModel)]="dataSetForEdit.state" name="state">
                </ng-select>
                </div>

                <div class="col-6">
                  <label class="col-title">
                    Zip code
                  </label>
                </div>
                <div class="col-6 mt-2 p-0">
                  <input #zip class="texttype2 w-90" (keyup)="numberValidation(zip.value)" type="text"
                  [(ngModel)]="dataSetForEdit.zipcode" name="zipcode"><br />
                <span class="redmsgFax" *ngIf="zipcodeErrorMsg">This field is required</span>
                <span class="redmsgFax redmsgCity" *ngIf="zipcodeErrorMsg2">Please enter valid zip
                  code</span>
                </div>

                <div class="col-6">
                  <label class="col-title">
                    Status
                  </label>
                </div>
                <div class="col-6 status-txt loc-switch mt-3">
                  <span class="loc_stat">
                    <label class="switch">
                      <input type="checkbox" class="imCheck"
                        (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'enrollflag',false)"
                        *ngIf="data.statusId!=2" checked>
                      <input type="checkbox" class="imCheck"
                        (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'enrollflag',true)"
                        *ngIf="data.statusId==2">
                      <span class="slider round"></span>
                    </label>
                    <span *ngIf="data.statusId!=2">Active</span>
                    <span *ngIf="data.statusId==2">Inactive</span>
                  </span>
                </div>

                <div class="col-6">
                  <label class="col-title" *ngIf="data.isSelected && data?.statusId!=2">
                    Flubok Quadrivalent Influenza Vaccine
                  </label>
                </div>
                <div class="col-6 status-txt loc-switch mt-3">
                  <span class="loc_stat" *ngIf="data.isSelected">
                    <label class="switch"
                      *ngIf="data?.statusId!=2 && data?.fluBlockOptedIn!='Not Available'"> <input
                        type="checkbox" class="imCheck"
                        (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokHighDoseActive',false)"
                        *ngIf="data?.fluBlockOptedIn=='Offered'" checked>
                      <input type="checkbox" class="imCheck"
                        (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokHighDoseActive',true)"
                        *ngIf="data?.fluBlockOptedIn!='Offered'">
                      <span class="slider round"></span>
                    </label>
                    <!-- <span *ngIf="data.flubokHighDoseActive">Offered</span> -->
                    <span *ngIf="data?.statusId!=2">{{data?.fluBlockOptedIn}}</span>

                  </span>
                </div>

                <div class="col-6">
                  <label class="col-title" *ngIf="data.isSelected && data?.statusId!=2">
                    Fluzone High-Dose Quadrivalent Influenza Vaccine
                  </label>
                </div>
                <div class="col-6 status-txt loc-switch mt-3">
                  <span class="loc_stat" *ngIf="data.isSelected">
                    <!-- <span *ngIf="!data.flubokActive">Not Offered</span> -->
                    <label class="switch"
                      *ngIf="data?.statusId!=2 && data?.fluZoneOptedIn!='Not Available'"> <input
                        type="checkbox" class="imCheck"
                        (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokActive',false)"
                        *ngIf="data?.fluZoneOptedIn=='Offered'" checked>
                      <input type="checkbox" class="imCheck"
                        (click)="updateFluZoneFluBlok(dataSetForEdit?.locatorId,'flubokActive',true)"
                        *ngIf="data?.fluZoneOptedIn!='Offered'">
                      <span class="slider round"></span>
                    </label>
                    <span *ngIf="data?.statusId!=2">{{data?.fluZoneOptedIn}}</span>
                  </span>
                </div>


                <div class="col-12 text-center">
                  <button (click)="cancelEditSection(data.locatorId)"
                  class="popover-close btn white-button popover-cancel-button mr-3">
                  Cancel</button>
                <button
                  *ngIf="phoneErrorMsg||cityErrorMsg||cityErrorMsg2 || zipcodeErrorMsg2 || zipcodeErrorMsg || addressErrorMsg || nameErrorMsg"
                  disabled (click)="SaveAction()" class="btn btn-primary">
                  &nbsp;Save&nbsp;</button>
                <button
                  *ngIf="!phoneErrorMsg && !cityErrorMsg2 && !zipcodeErrorMsg2 && !zipcodeErrorMsg && !addressErrorMsg && !nameErrorMsg"
                  (click)="SaveAction()" class="btn btn-primary">
                  &nbsp;Save&nbsp;</button>
                </div>
              </div>
            </div>
            </section>
            </ng-container>
            <ng-container *ngIf="ordersList?.length==0">
                <div class="alignCenter">No matching locations</div>
            </ng-container>

          </div>
        <!--mobile view ends-->
      </div>
    </section>


  </div>
</div>